import React from "react";

/**
 * Small status pill, following the same shape/semantics as the existing
 * `advanced-search__status-pill` (rounded pill, positive/attention
 * variants) without depending on AdvancedSearch's own scss - kept generic
 * so other pages (like PN Data Mapping) can use it too.
 */
const StatusPill = ({ tone = "neutral", children }) => (
  <span className={`status-pill status-pill--${tone}`}>{children}</span>
);

export default StatusPill;
